import i18next from 'i18next';
import React from 'react';

import { MenuItem } from '@material-ui/core';
import TextInput from 'components/TextInput/TextInput';
import { useTranslation } from 'react-i18next';
import useStyles from './RecordDialogLayoutStyles';
import { DEFAULT_ADDITIONAL_SALARY_TYPES } from 'LixaniAPI/enums';

import { orderBy } from 'lodash';
import { useSelector } from 'react-redux';
import { selectEmployerAllowancesByBusinessId } from 'store/employerAllowances/selectors/employerAllowances.selectors';
import { selectRecordEditSelectedResource } from 'store/records/selectors/records.selectors';

export const TypeChange = ({
  handleChange,
  handleSubTypeChange,
  selectedType,
  disabled,
  recordType,
  subType,
}) => {
  const selectedResource = useSelector(selectRecordEditSelectedResource);

  const employerAllowances = useSelector((state) =>
    selectEmployerAllowancesByBusinessId(
      state,
      selectedResource?.employerBusinessId || ''
    )
  );

  const recordTypeList = {
    work: i18next.t('common:record.type.work'),
    projectWork: i18next.t('common:record.type.projectWork'),
    break: i18next.t('common:record.type.break'),
    coffeeBreak: i18next.t('common:record.type.coffee_break'),
    mealBreak: i18next.t('common:record.type.meal_break'),
    shift: i18next.t('common:record.type.shift'),
    absence: i18next.t('common:record.type.absence'),
    benefit: i18next.t('common:record.type.benefit'),
    ride: i18next.t('common:record.type.ride'),
    item: i18next.t('common:record.type.item'),
    negative: i18next.t('common:record.type.negative'),
  };

  const isLegacySickLeaveOrHoliday =
    selectedType === 'ABSENCE_SICK_LEAVE' ||
    selectedType === 'ABSENCE_VACATION_PAID';

  const allTypeOptions = [
    { value: 'WORK', label: recordTypeList.work },
    { value: 'PROJECTWORK', label: recordTypeList.projectWork },
    { value: 'BREAK', label: recordTypeList.break },
    { value: 'BREAK_COFFEE', label: recordTypeList.coffeeBreak },
    { value: 'BREAK_MEAL', label: recordTypeList.mealBreak },
    { value: 'SHIFT', label: recordTypeList.shift },
    { value: 'ABSENCE', label: recordTypeList.absence },
    { value: 'BENEFIT', label: recordTypeList.benefit },
    { value: 'RIDE', label: recordTypeList.ride },
    { value: 'ITEM', label: recordTypeList.item },
    { value: 'NEGATIVE', label: recordTypeList.negative },
  ];

  const absenceTypeOptions = Object.values(
    DEFAULT_ADDITIONAL_SALARY_TYPES
  ).filter(
    (salaryType) =>
      salaryType.baseType === 'ABSENCE' &&
      (employerAllowances?.some(
        (allowance) => allowance.salaryType === salaryType.salaryType
      ) ||
        salaryType.salaryType === 'SICK_LEAVE' ||
        salaryType.salaryType === 'HOLIDAY_PAY')
  );

  const selectableTypeOptions = ['WORK', 'PROJECTWORK', 'ABSENCE'];

  let typeOptions = [];

  if (recordType === 'BREAK') {
    typeOptions = allTypeOptions.filter((typeOption) => {
      return (
        typeOption.value.includes('BREAK') || typeOption.value === selectedType
      );
    });
  } else if (recordType === 'ALLOWANCE') {
    typeOptions = allTypeOptions.filter(
      (typeOption) => typeOption.value === 'RIDE'
    );
  } else {
    typeOptions = allTypeOptions.filter((item) =>
      selectableTypeOptions.includes(item.value)
    );
  }

  const { t } = useTranslation('common');
  const classes = useStyles();

  const typeSelected = isLegacySickLeaveOrHoliday
    ? allTypeOptions.find((type) => type.value === 'ABSENCE')
    : allTypeOptions.find((type) => type.value === selectedType);

  return (
    <div>
      <TextInput
        displayEmpty
        fullWidth
        id="edit-record-type-select"
        label={t('calendar.type')}
        MenuProps={{
          PaperProps: {
            className: classes.menuPaper,
          },
        }}
        onChange={(e) => handleChange(e.target.value)}
        select
        shrink
        value={typeSelected.value}
        disabled={disabled}
      >
        {typeOptions.map((item) => (
          <MenuItem
            className={classes.menuItem}
            key={item.value}
            value={item.value}
          >
            {item.label}
          </MenuItem>
        ))}
      </TextInput>

      {typeSelected.value.includes('ABSENCE') ? (
        <div style={{ marginTop: '20px' }}>
          <TextInput
            displayEmpty
            fullWidth
            id="edit-record-sub-type-select"
            label={'Poissaolon tyyppi'}
            MenuProps={{
              PaperProps: {
                className: classes.menuPaper,
              },
            }}
            onChange={(e) => handleSubTypeChange(e.target.value)}
            select
            shrink
            value={subType}
            disabled={disabled}
          >
            {orderBy(
              absenceTypeOptions,
              [(item) => t(`${item.salaryName}`)],
              'asc'
            ).map((item) => (
              <MenuItem
                className={classes.menuItem}
                key={item.salaryType}
                value={item.salaryType}
              >
                {t(`${item.salaryName}`)}
              </MenuItem>
            ))}
          </TextInput>
        </div>
      ) : null}
    </div>
  );
};
